export const CATEGORIE_PRODUITS_POTENTIEL_NOURRICIER = {
  ELEVAGE: {
    couleur: "#B57A60",
    libelle: "Elevage",
    libelle_court: "Viande, oeufs et produits laitiers",
    libelle_affichage: "Viande, oeufs et produits laitiers",
  },
  FRUITS: {
    couleur: "#A261C0",
    libelle: "Fruits",
    libelle_court: "Fruits",
    libelle_affichage: "Fruits",
  },
  LEGUMES: {
    couleur: "#91C423",
    libelle: "Légumes",
    libelle_court: "Légumes",
    libelle_affichage: "Légumes",
  },
  CEREALES: {
    couleur: "#F9B233",
    libelle: "Céréales et autres cultures",
    libelle_court: "Céréales",
    libelle_affichage:
      "Céréales et grandes cultures (hors alimentation animale)",
  },
  BIODIV: {
    couleur: "#38a13f",
    libelle: "Surfaces pour Biodiversité",
    libelle_court: "Surfaces pour Biodiversité",
    libelle_affichage: "Surfaces pour Biodiversité",
  },
};

// ICI UNE SEPARATION EXPLICITE ENTRE VIANDE ET PRODUITS LAITIERS
// PRINCIPALEMENT POUR LES TREEMAPS
export const CATEGORIE_PRODUITS_POTENTIEL_NOURRICIER_DETAILLE = {
  ELEVAGE: {
    couleur: "#B57A60",
    libelle: "Elevage",
    libelle_court: "Viande & Oeufs",
    libelle_affichage: "Viande et oeufs",
  },
  FRUITS: {
    couleur: "#A261C0",
    libelle: "Fruits",
    libelle_court: "Fruits",
    libelle_affichage: "Fruits",
  },
  LEGUMES: {
    couleur: "#91C423",
    libelle: "Légumes",
    libelle_court: "Légumes",
    libelle_affichage: "Légumes",
  },
  CEREALES: {
    couleur: "#F9B233",
    libelle: "Céréales et autres cultures",
    libelle_court: "Céréales",
    libelle_affichage:
      "Céréales et grandes cultures (hors alimentation animale)",
  },
  LAIT: {
    couleur: "#B57A60",
    libelle: "Produits Laitiers",
    libelle_court: "Produits Laitiers",
    libelle_affichage: "Produits Laitiers",
  },
  BIODIV: {
    couleur: "#38a13f",
    libelle: "Surfaces pour Biodiversité",
    libelle_court: "Surfaces pour Biodiversité",
    libelle_affichage: "Surfaces pour Biodiversité",
  },
};

export const CATEGORIE_PRODUITS_POTENTIEL_NOURRICIER_DETAILLE_NIVEAU3 = {
  VIANDE_ROUGE: {
    couleur: "#B57A60",
    libelle: "Viande Rouge",
    libelle_court: "Viande Rouge",
  },
  VIANDE_BLANCHE: {
    couleur: "#E8B684",
    libelle: "Viande Blanche",
    libelle_court: "Viande Blanche",
  },
  FRUITS: {
    couleur: "#A261C0",
    libelle: "Fruits",
    libelle_court: "Fruits",
  },
  LEGUMES: {
    couleur: "#91C423",
    libelle: "Légumes",
    libelle_court: "Légumes",
  },
  CEREALES: {
    couleur: "#F9B233",
    libelle: "Céréales et autres cultures",
    libelle_court: "Céréales",
  },
  PRODUITS_LAITIERS: {
    couleur: "#C4E3FB",
    libelle: "Produits Laitiers",
    libelle_court: "Produits Laitiers",
  },
};
